module.exports = "\n<div style=\"display: block;\">\n  <span class=\"heading_title\">{{title}}</span>\n  <canvas  baseChart \n    [datasets]=\"data\"\n    [labels]=\"labels\"\n    [options]=\"options\"\n    [legend]=\"pieChartLegend\"\n    [colors]=\"pieChartColors\" \n    [chartType]=\"pieChartType\">\n  </canvas>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2327239889/src/src/app/common/dynamic-vendor-pie-chart/dynamic-vendor-pie-chart.component.html
// module id = ../../../../../src/app/common/dynamic-vendor-pie-chart/dynamic-vendor-pie-chart.component.html
// module chunks = main